import styled from "styled-components";
import Table from "../DataTable";
import ListWithPagination from "../ListsWithPagination";
import ActionImageButton from "../DataTable/ActionImageButton";
import { Text } from "../../config/Constants";

export interface BerthTariffTableProps {
  data: {
    id: string;
    range: string;
    annual: string;
    monthly: string;
    daily: string;
    dropOrPickUp: string;
    isActive: boolean;
  }[];
  onEditClick: (id: string) => void;
  isTableDataLoading: boolean;
}

const BerthTariffTable = ({
  data,
  onEditClick,
  isTableDataLoading,
}: BerthTariffTableProps) => {
  const tbaOrData = (data: string) => {
    return <div>{data === "" || Number(data) === 0 ? "TBA" : data}</div>;
  };
  
  const columns = [
    {
      path: "range",
      label: "LOA-M",
    },
    {
      path: "annual",
      label: "Annual Berth Dues (QAR)",
      content: (outlet: { annual: string }) => tbaOrData(outlet.annual),
    },
    {
      path: "monthly",
      label: "Monthly Berth Dues (QAR)",
      content: (outlet: { monthly: string }) => tbaOrData(outlet.monthly),
    },
    {
      path: "daily",
      label: "Daily Berth Dues (QAR)",
      content: (outlet: { daily: string }) => tbaOrData(outlet.daily),
    },
    {
      path: "dropOrPickUp",
      label: "Drop Off/Pick Up (QAR)",
      content: (outlet: { dropOrPickUp: string }) => tbaOrData(outlet.dropOrPickUp),
    },
    {
      path: "isActive",
      label: "Status",
      content: (outlet: { isActive: boolean }) => (
        <div>{outlet.isActive ? "Enabled" : "Disabled"}</div>
      ),
    },
    {
      label: "Edit",
      key: "edit",
      content: (outlet: { id: number | string | any }) => (
        <ActionImageButton
          onClick={() => onEditClick(outlet.id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label="Edit Berth"
        />
      ),
    },
  ];
  return (
    <>
      <TableWrapper>
        <Table
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={Text.berthTariff}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};

export default BerthTariffTable;

const TableWrapper = styled.div`
  display: block;
  margin-top: 1rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
